import {ComponentDesc} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/ComponentDesc';
import {PositioningType} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/layouts/PositioningType';
import {SelfDirectedLayout} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/panels/properties/layout/SelfDirectedLayout';
import {PropertyView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/panels/properties/PropertyView';
import {Col} from '@mintdata/mint-kit/impl/properties/components/col/Col';
import {HeadingLabel} from '@mintdata/mint-kit/impl/properties/components/headingLabel/HeadingLabel';
import {Row} from '@mintdata/mint-kit/impl/properties/components/row/Row';
import {Section} from '@mintdata/mint-kit/impl/properties/components/section/Section';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./ComponentLayout.less');
const cx = classnames.bind(styles);

interface IComponentLayoutProps
{
    componentDesc:ComponentDesc;
}

@observer
export class ComponentLayout extends React.Component<IComponentLayoutProps, any>
{
    public render():JSX.Element
    {
        const {componentDesc} = this.props;
        const isParentDirected:boolean = PositioningType.isParentDirected(componentDesc.layout.positioningType);

        return (
            <div>
                <Section className={styles.base}>
                    <Row>
                        <HeadingLabel text="Layout" className={cx('headingLabel')} />
                    </Row>
                    <Row>
                        <PropertyView hideTitle componentDesc={componentDesc} prop={componentDesc.layoutProp}>
                            {
                                isParentDirected && componentDesc.box.parent
                                    ? <PropertyView
                                        hideTitle
                                        componentDesc={componentDesc.box.parent.componentDesc}
                                        prop={componentDesc.box.parent.componentDesc.childLayoutProp}
                                        isParentProperty={true}
                                    />
                                    : <SelfDirectedLayout componentDesc={componentDesc} />
                            }
                        </PropertyView>
                    </Row>
                    {componentDesc.childLayoutProp && <Row>
                        <Col size={1} gridSize={1}>
                            <PropertyView
                                hideTitle
                                componentDesc={componentDesc}
                                prop={componentDesc.childLayoutProp}
                            />
                        </Col>
                    </Row>}
                </Section>
            </div>
        );
    }
}
